import template from './noteTypeModalLauncher.html';
import controller from './noteTypeModalLauncherCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    onClose: '&',
  },
};
